export const WINT_AI_CONTROL_URL = process.env.REACT_APP_SUPPORT_DASHBOARD_WINT_AI_CONTROL_URL;
export const WINT_LIGHTNING_FORCE_URL = 'https://wint.lightning.force.com'
export const WINT_ORGANIZATIONS_ROUTE = 'en/organizations';
export const WINT_EMAIL_SUFFIX = '@wint.ai';
export const WINT_SITES_ROUTE = 'en/sites';
export const WINT_WATER_SYSTEMS_ROUTE = 'water_systems'
export const DATE_LOCALE = 'he';
export const HOURS = 0;
export const HOURS_LABEL = 'hour';
export const DAYS = 1;
export const DAYS_LABEL = 'day';
export const WEEKS = 2;
export const WEEKS_LABEL = 'week';
export const MONTHS = 3;
export const MONTHS_LABEL = 'month';
export const VARIANT_SITES = 'SITES';
export const VARIANT_SYSTEMS = 'SYSTEMS';
export const SITE_ENTITY_LABEL = 'site';
export const WATER_SYSTEM_ENTITY_LABEL = 'waterSystem';
export const SITE_ENTITY = 'Site';
export const SYSTEM_ENTITY = 'System';
export const WATER_CONSUMPTION_NAME = 'Water Consumption';
export const HIGH_FLOW = 'High Flow';
export const MODERATE_FLOW = 'Moderate Flow';
export const LOW_FLOW = 'Low Flow';
export const POTENTIAL_WASTE = 'Potential Waste';
export const MAIN_INLET_TITLE = 'Main Inlet';
export const COOLING_TOWER_TITLE = 'Cooling Tower';
export const ALL_THE_REST_TITLE = 'All The Rest';
export const HIGH_FLOW_LEAK = 'MAJOR';
export const MODERATE_FLOW_LEAK = 'MODERATE';
export const LOW_FLOW_LEAK = 'MINOR';
export const N_LAST_DAYS = 30;
export const MAX_SELECTION_LIMIT = 4;
export const MAX_ENTITIES_MULTI_SELECT = 11;
export const SELECT_ALL_OBJECT = {value: -1, name: 'Select All', label: 'Select All'};
export const LITERS_TO_GALLONS = 0.2641720524;
export const LITERS_TO_CCF = 0.000353146667;
export const LITERS_TO_CUBIC_METERS = 0.001;
export const DEFAULT_WATER_PRICE = 1520;
export const EXCEL_TITLE_WATER_CONSUMPTION = 'Water consumption data';
export const EXCEL_TITLE_NUMBER_OF_LEAKS = 'Number of leak alerts over time';
export const OFFSET_START_DATE_LIMIT = new Date(2020, 7, 1);
export const UNKNOWN_USER_ID = -1;
export const BAR_CHAR_ENTITIES_LEN_LIMIT = 1100;
export const CURRENT_USER_ID_COOKIE = 'current-user-id';
export const VIEW_AS_USER_ID_COOKIE = 'view-as-user-id';
export const PULSE_TO_LITER = 20.39;
export const WARNING_FACTOR = 1.6;
export const CLOSED_FACTOR = 2;
export const REFERENCE_DIAMETER_ID = 1;
export const ENTER_KEY_CODE = 13;
export const MAX_PAGE_SIZE = 15000;
export const DEFAULT_PAGE_SIZE = 15;
export const INDEX_NOT_FOUND = -1;
export const VALVES_LOW_CASE = 'valves'
export const METERS_LOW_CASE = 'meters'
export const METER_UUIDS = 'meterUuids'
export const VALVE_UUIDS ='valveUuids'
export const STANDARD_USER = 'STANDARD';
export const ADMIN_USER = 'ADMIN';
export const HARDWARE_CATALOG_ADMIN = 'HW_CATALOG_ADMIN';
export const CU_ONLINE = 'CU Online';
export const CU_OFFLINE = 'CU Offline';
